const state = {

}

const getters = {
	isCaster: (state, getters, rootState, rootGetters) => {
		const spellsKnown = rootState.Character.Levels[ rootGetters.currentLevel ].Spells.Known
		for (const spellLevel in spellsKnown){
			if (spellsKnown[ spellLevel ] != 0){
				return true
			}
		}
		return false
	},
	isCasterAtLevel: (state, getters, rootState) => (concernedLevel) => {
		var levels = rootState.Character.Levels
		for (const level in levels) {
			let spellsKnown = levels[level].Spells.Known
			for (const spellLevel in spellsKnown) {
				if (level <= concernedLevel && spellsKnown[spellLevel] != 0){
					return true
				}
			}
		}
		return false
	},
	known: (state, getters, rootState, rootGetters) => {
		var output = {}
		const spellsKnown = rootState.Character.Levels[ rootGetters.currentLevel ].Spells.Known
		for (const spellLevel in spellsKnown){
			if (spellsKnown[ spellLevel ] != 0){
				output[ spellLevel ] = spellsKnown[ spellLevel ]
			}
		}
		return output
	},
	list: (state, getters, rootState, rootGetters) => {
		var output = {}
		const spellsKnown = rootState.Character.Levels[ rootGetters.currentLevel ].Spells.List
		for (const spellLevel in spellsKnown){
			if (spellsKnown[ spellLevel ] != 0){
				output[ spellLevel ] = spellsKnown[ spellLevel ]
			}
		}		
		return output
	},
	perDay: (state, getters, rootState, rootGetters) => {
		var output = {}
		const spellsPerDay = rootState.Character.Levels[ rootGetters.currentLevel ].Spells.PerDay
		for (const spellLevel in spellsPerDay){
			if (spellsPerDay[ spellLevel ] != 0){
				output[ spellLevel ] = spellsPerDay[ spellLevel ]
			}
		}		
		return output
	},
	saveDC: (state, getters, rootState, rootGetters) => {
		var saveDCs = {}
		const spellsKnown = getters.known
		const abilityMod = rootGetters['character/abilityScores/abilityMods'][rootState.Character.Misc.CastingStat]
		const dcMod = parseInt(rootState.Character.Misc.SpellSaveDCMod)
		for( const spellLevel in spellsKnown ){
			saveDCs[ spellLevel ] = 10 + parseInt(spellLevel) + abilityMod + dcMod
		}
		return saveDCs
	}
}

const actions = {

}

const mutations = {

}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}